import * as types from "../constants";

window.NodeList.prototype.forEach = window.Array.prototype.forEach;

const setPageName = pageName => ({type: types.SET_PAGENAME, pageName});

const setMetaData = (pages, pagename, content) =>
{
	let obj = {"title": "", "description": "", "keywords": ""};

	if (pages[pagename] === undefined)
	{

		if (pages.home !== undefined)
		{
			obj = {...pages.home}
		}

	}
	else
	{
		if (content !== undefined)
		{
			if (content.seo && content.seo.title && content.seo.title !== '')
			{
				obj = {...content.seo}
			}
			else
			{
				if (/\{0}/gi.test(pages[pagename].title) && content.name !== undefined)
				{
					obj = {...pages[pagename], title: pages[pagename].title.replace(/\{0}/gi, content.name)}
				}
				else if (pagename === 'game')
				{
					obj = {...pages[pagename], title: pages[pagename].title + ' ' + content.name}
				}
				else
				{
					obj = {...pages[pagename]}
				}
			}
		}
		else
		{
			obj = {...pages[pagename]}
		}
	}

	document.querySelectorAll('title').forEach(e => (e.innerText = obj.title));

	document.querySelectorAll('meta[name="description"]').forEach(e => e.setAttribute('content', obj.description));

	document.querySelectorAll('meta[name="keywords"]').forEach(e => e.setAttribute('content', obj.keywords));

};

export const setPageInfo = (pageName, content) => (dispatch, getState) =>
{

	const {pages} = getState();

	setMetaData(pages, pageName.replace(' ', '-'), content);
	dispatch(setPageName(pageName));

}